import { apiGatewayUrl } from '../../config';
import { ApiGatewayClient } from '../../utils/api-gateway-client.util';
import { ContentTypes, HttpMethod } from '../../utils/enums';
import { StorefrontModel } from '../../utils/interfaces';

/**
 * This service has the main propose to provide or manage the API calls and data request for
 * Calculator functionality.
 */
export class CalculatorService {
    private client: ApiGatewayClient;
    private headers = {
        'Content-Type': ContentTypes.json,
        Accept: ContentTypes.json,
    };
    /**
     * Instantiates a new identified ApiGatewayClient
     */
    constructor() {
        this.client = new ApiGatewayClient();
    }

    /**
     * This method sends retrieved info by the Financial calculator to the storefront
     * @param brand client consumer of the widget
     * @param storefrontBody Retrieved calculator information for storefront
     */
    public async sendStorefrontData(
        brand: string,
        storefrontBody: StorefrontModel,
        isUsed: boolean,
    ): Promise<StorefrontModel> {
        const url = `${apiGatewayUrl}/bff/mx-storefront-service/v1/autocredit/mx/${brand.toLowerCase()}/${
            isUsed ? 'used' : 'new'
        }/data`;
        const request = {
            url,
            method: HttpMethod.post,
            data: storefrontBody,
            headers: this.headers,
        };

        const retrievedData = await this.client.sendRequest<StorefrontModel>(
            request,
        );
        const result = retrievedData.data;

        return result;
    }
}
